export type Movie = {
  id: number;
  title: string;
  year: number;
  genres: string[];
  country: string;
  director: string;
  runtime: number;
  language: string;
  rating: number;
  releaseDate: string;
  poster: string;
  tagline: string;
  synopsis: string;
  cast: string[];
};

export const movies: Movie[] = [
  {
    id: 1,
    title: '夜色蝶影',
    year: 2019,
    genres: ['剧情', '悬疑'],
    country: '日本',
    director: '佐藤健一',
    runtime: 118,
    language: '日语',
    rating: 8.6,
    releaseDate: '2019-10-18',
    poster:
      'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20poster%20depicting%20a%20graceful%20woman%20in%20a%20flowing%20indigo%20kimono%20as%20an%20artistic%20silhouette%20against%20a%20deep%20midnight%20blue%20sky%2C%20a%20single%20glowing%20butterfly%20motif%2C%20moody%20atmospheric%20lighting%2C%20soft%20film%20grain%2C%20tasteful%20minimal%20composition%2C%20dark%20cinematic%20tones%20with%20warm%20amber%20highlights%2C%20high%20detail%2C%20professional%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-01&orientation=portrait',
    tagline: '在霓虹与夜色之间，她寻找着真正的自己。',
    synopsis:
      '故事发生在东京一间濒临倒闭的老式剧场。女主角一夜之间从舞台的荣光跌落到生活的底层，为了守住剧场与伙伴们的梦想，她在城市的暗流中奔波。影片以细腻的镜头语言描绘了都市女性在理想与现实之间的挣扎，探讨了身份、记忆与自我认同的主题。',
    cast: ['北条麻妃', '高桥凉介', '山口惠子', '中村和也'],
  },
  {
    id: 2,
    title: '东京雨夜',
    year: 2020,
    genres: ['爱情', '剧情'],
    country: '日本',
    director: '小林绫',
    runtime: 112,
    language: '日语',
    rating: 8.2,
    releaseDate: '2020-06-12',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20rainy%20night%20city%20street%20film%20poster%20with%20a%20woman%20holding%20a%20translucent%20umbrella%2C%20reflections%20of%20distant%20city%20lights%20on%20wet%20pavement%2C%20romantic%20melancholic%20mood%2C%20deep%20blue%20and%20warm%20amber%20color%20contrast%2C%20soft%20bokeh%2C%20artistic%20tasteful%20composition%2C%20film%20grain%2C%20professional%20movie%20poster%20aesthetic%2C%20high%20detail&width=600&height=900&seq=bhposter-02&orientation=portrait',
    tagline: '一场大雨，让两条平行的人生短暂交汇。',
    synopsis:
      '一个连绵阴雨的夏天，两个素不相识的人在末班车错过后于站台相遇。他们分享了一把伞，也分享了各自不愿提起的往事。影片用克制而温柔的方式，讲述了一段没有结局却难以忘怀的相遇。',
    cast: ['北条麻妃', '松本润', '井上真央'],
  },
  {
    id: 3,
    title: '樱花残照',
    year: 2018,
    genres: ['剧情', '历史'],
    country: '日本',
    director: '渡边修',
    runtime: 134,
    language: '日语',
    rating: 8.8,
    releaseDate: '2018-03-30',
    poster:
      'https://readdy.ai/api/search-image?query=Poetic%20cinematic%20film%20poster%20set%20in%20a%20traditional%20Japanese%20garden%20at%20dusk%20with%20falling%20cherry%20blossom%20petals%2C%20an%20elegant%20woman%20in%20a%20subtle%20historical%20kimono%20shown%20in%20artistic%20profile%2C%20soft%20golden%20twilight%20light%2C%20warm%20rose%20and%20deep%20teal%20tones%2C%20tasteful%20graceful%20composition%2C%20film%20texture%2C%20high%20detail%2C%20premium%20movie%20poster%20style&width=600&height=900&seq=bhposter-03&orientation=portrait',
    tagline: '花开花落，是一个时代温柔的告别。',
    synopsis:
      '故事横跨昭和末年与平成初年，围绕一个经营了三代人的花道世家展开。女主角作为家中最小的女儿，在传统与现代的夹缝中做出了自己的选择。影片以四季流转为线索，刻画了家族记忆与时代更迭的交织。',
    cast: ['北条麻妃', '田中裕子', '绪形拳', '宫崎葵'],
  },
  {
    id: 4,
    title: '无声告白',
    year: 2021,
    genres: ['剧情'],
    country: '日本',
    director: '中岛美咲',
    runtime: 105,
    language: '日语',
    rating: 8.0,
    releaseDate: '2021-09-03',
    poster:
      'https://readdy.ai/api/search-image?query=Minimalist%20quiet%20cinematic%20film%20poster%20with%20a%20woman%20standing%20alone%20in%20a%20bright%20empty%20white%20room%20beside%20a%20large%20window%2C%20soft%20diffused%20daylight%2C%20contemplative%20solitary%20mood%2C%20pale%20neutral%20palette%20with%20one%20muted%20amber%20accent%2C%20restrained%20elegant%20composition%2C%20fine%20film%20grain%2C%20artistic%20tasteful%20movie%20poster%2C%20high%20detail&width=600&height=900&seq=bhposter-04&orientation=portrait',
    tagline: '有些话，从来不需要说出口。',
    synopsis:
      '一位在城市里独自生活的中年女性，用一台旧相机记录着身边人的日常。当她决定把这些照片办成一次小型展览时，那些被忽略的温柔与遗憾也一并浮现。影片节奏舒缓，情感真挚。',
    cast: ['北条麻妃', '树木希林', '役所广司'],
  },
  {
    id: 5,
    title: '逆流之河',
    year: 2017,
    genres: ['剧情', '动作'],
    country: '日本',
    director: '佐藤健一',
    runtime: 121,
    language: '日语',
    rating: 7.9,
    releaseDate: '2017-11-25',
    poster:
      'https://readdy.ai/api/search-image?query=Powerful%20cinematic%20film%20poster%20featuring%20a%20woman%20standing%20resolutely%20on%20a%20rocky%20riverbank%20as%20turbulent%20rapids%20surge%20past%2C%20dramatic%20overcast%20lighting%2C%20a%20sense%20of%20determination%20and%20strength%2C%20cool%20slate%20blue%20tones%20with%20muted%20orange%20highlights%2C%20tasteful%20artistic%20composition%2C%20subtle%20film%20grain%2C%20premium%20movie%20poster%20style%2C%20high%20detail&width=600&height=900&seq=bhposter-05&orientation=portrait',
    tagline: '哪怕逆流而上，也要抵达想去的地方。',
    synopsis:
      '一名退役的皮划艇运动员回到故乡，却发现曾经的河道被改造成了商业项目。为了守护这条承载着几代人记忆的河流，她重新握起了船桨，也重新面对了自己逃避多年的过去。',
    cast: ['北条麻妃', '真田广之', '绫濑遥'],
  },
  {
    id: 6,
    title: '白塔之下',
    year: 2022,
    genres: ['剧情', '悬疑'],
    country: '日本',
    director: '黑泽清',
    runtime: 127,
    language: '日语',
    rating: 8.4,
    releaseDate: '2022-04-08',
    poster:
      'https://readdy.ai/api/search-image?query=Atmospheric%20suspense%20film%20poster%20showing%20a%20lone%20woman%20gazing%20up%20at%20a%20tall%20white%20tower%20shrouded%20in%20thick%20fog%2C%20mysterious%20uncanny%20mood%2C%20desaturated%20cool%20palette%20with%20a%20single%20amber%20light%2C%20artistic%20tasteful%20composition%2C%20subtle%20film%20grain%2C%20cinematic%20depth%2C%20high%20detail%2C%20professional%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-06&orientation=portrait',
    tagline: '雾散之后，真相未必令人释怀。',
    synopsis:
      '海边小镇上矗立着一座废弃的白色灯塔。多年后，一位回来处理家族遗产的女性发现，灯塔里藏着关于母亲失踪的全部答案。影片以缓慢累积的紧张感，揭开一个家庭数十年的秘密。',
    cast: ['北条麻妃', '浅野忠信', '满岛光'],
  },
  {
    id: 7,
    title: '夏日回声',
    year: 2016,
    genres: ['爱情', '剧情'],
    country: '日本',
    director: '小林绫',
    runtime: 98,
    language: '日语',
    rating: 7.7,
    releaseDate: '2016-07-16',
    poster:
      'https://readdy.ai/api/search-image?query=Bright%20nostalgic%20summer%20film%20poster%20with%20a%20woman%20walking%20along%20a%20quiet%20seaside%20shoreline%20at%20golden%20hour%2C%20gentle%20warm%20sunlight%2C%20soft%20sea%20breeze%2C%20warm%20amber%20and%20pale%20sky%20blue%20tones%2C%20air%20of%20gentle%20nostalgia%2C%20tasteful%20graceful%20composition%2C%20film%20grain%2C%20high%20detail%2C%20premium%20movie%20poster%20style&width=600&height=900&seq=bhposter-07&orientation=portrait',
    tagline: '那个夏天，海风记住了所有人的名字。',
    synopsis:
      '海边小镇的一间旧民宿即将拆除，四位儿时的伙伴在最后一个夏天重聚。他们翻出旧录音带，听到了十年前的自己留下的声音，也终于坦白了一直说不出口的心事。',
    cast: ['北条麻妃', '福山雅治', '广濑铃'],
  },
  {
    id: 8,
    title: '京都物语',
    year: 2019,
    genres: ['剧情'],
    country: '日本',
    director: '渡边修',
    runtime: 143,
    language: '日语',
    rating: 8.9,
    releaseDate: '2019-05-24',
    poster:
      'https://readdy.ai/api/search-image?query=Elegant%20slow%20cinema%20film%20poster%20set%20on%20an%20old%20Kyoto%20stone%20lane%20lined%20with%20wooden%20machiya%20houses%20and%20a%20lone%20woman%20in%20a%20refined%20kimono%20seen%20from%20behind%2C%20soft%20lantern%20light%20at%20dusk%2C%20warm%20muted%20earth%20and%20deep%20indigo%20tones%2C%20tasteful%20serene%20composition%2C%20subtle%20film%20texture%2C%20high%20detail%2C%20premium%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-08&orientation=portrait',
    tagline: '一座城，三代人，一段未曾说完的话。',
    synopsis:
      '一位陶艺家回到京都照顾年迈的外婆，意外发现了外婆年轻时写给一位陌生人的信。在寻找收信人的过程中，她重新认识了这座古城，也重新理解了自己的家人。',
    cast: ['北条麻妃', '宫本信子', '三浦友和', '小松菜奈'],
  },
  {
    id: 9,
    title: '霓虹尽头',
    year: 2021,
    genres: ['悬疑', '剧情'],
    country: '日本',
    director: '园子温',
    runtime: 109,
    language: '日语',
    rating: 8.1,
    releaseDate: '2021-12-10',
    poster:
      'https://readdy.ai/api/search-image?query=Gritty%20urban%20neo%20noir%20film%20poster%20with%20a%20woman%20standing%20at%20the%20end%20of%20a%20narrow%20alley%20lit%20by%20glowing%20signs%2C%20rain%20slicked%20pavement%2C%20mysterious%20tense%20mood%2C%20contrasting%20deep%20blue%20shadows%20and%20warm%20orange%20glow%2C%20tasteful%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20professional%20movie%20poster%20style&width=600&height=900&seq=bhposter-09&orientation=portrait',
    tagline: '在霓虹的尽头，每个人都藏着秘密。',
    synopsis:
      '一位调查记者为了找到失踪多时的同事，独自潜入城市夜生活的深处。随着线索层层展开，她发现真相远比想象中复杂。影片以强烈的视觉风格呈现了都市的孤独与欲望。',
    cast: ['北条麻妃', '妻夫木聪', '安藤樱'],
  },
  {
    id: 10,
    title: '雪国来信',
    year: 2020,
    genres: ['爱情', '剧情'],
    country: '日本',
    director: '岩井俊二',
    runtime: 116,
    language: '日语',
    rating: 8.3,
    releaseDate: '2020-01-17',
    poster:
      'https://readdy.ai/api/search-image?query=Serene%20winter%20film%20poster%20showing%20a%20woman%20in%20a%20warm%20wool%20coat%20standing%20in%20a%20quiet%20snow%20covered%20village%2C%20soft%20falling%20snowflakes%2C%20gentle%20overcast%20light%2C%20cool%20pale%20white%20and%20muted%20amber%20tones%2C%20delicate%20melancholic%20atmosphere%2C%20tasteful%20elegant%20composition%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20premium%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-10&orientation=portrait',
    tagline: '有些信，寄了十年才被读到。',
    synopsis:
      '在常年积雪的山间小镇，邮局里积压着一封投递了十年都未能送达的信。新任的邮递员决定亲手把它送到收信人手中，也由此牵出一段被时间掩埋的爱情。',
    cast: ['北条麻妃', '松隆子', '堺雅人'],
  },
  {
    id: 11,
    title: '深海之光',
    year: 2023,
    genres: ['剧情', '悬疑'],
    country: '日本',
    director: '中岛美咲',
    runtime: 124,
    language: '日语',
    rating: 8.7,
    releaseDate: '2023-08-25',
    poster:
      'https://readdy.ai/api/search-image?query=Deep%20ocean%20themed%20cinematic%20film%20poster%20depicting%20a%20woman%20floating%20weightlessly%20in%20dark%20blue%20water%20toward%20a%20single%20shaft%20of%20golden%20light%20from%20above%2C%20ethereal%20mysterious%20mood%2C%20deep%20indigo%20and%20warm%20luminous%20highlights%2C%20tasteful%20artistic%20composition%2C%20subtle%20particles%2C%20high%20detail%2C%20professional%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-11&orientation=portrait',
    tagline: '潜得越深，越靠近光。',
    synopsis:
      '一名海洋生物学家在一次深潜任务中遭遇事故，醒来后发现自己失去了部分记忆。为了找回失落的片段，她再次潜入深海，也在那里找到了比真相更重要的东西。',
    cast: ['北条麻妃', '冈田准一', '长泽雅美'],
  },
  {
    id: 12,
    title: '迷途之森',
    year: 2018,
    genres: ['悬疑', '剧情'],
    country: '日本',
    director: '黑泽清',
    runtime: 102,
    language: '日语',
    rating: 7.8,
    releaseDate: '2018-10-05',
    poster:
      'https://readdy.ai/api/search-image?query=Enigmatic%20film%20poster%20with%20a%20woman%20walking%20alone%20through%20a%20misty%20dense%20forest%20with%20tall%20trees%20fading%20into%20fog%2C%20cool%20desaturated%20green%20and%20grey%20tones%20with%20a%20soft%20warm%20light%20break%2C%20mysterious%20quiet%20mood%2C%20tasteful%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20premium%20movie%20poster%20style&width=600&height=900&seq=bhposter-12&orientation=portrait',
    tagline: '森林记得每一个迷路的人。',
    synopsis:
      '一群徒步旅行者在深山中偏离了路线，第二天清晨醒来，发现队里少了一个人，而所有人都对昨夜发生的事讳莫如深。影片以压抑的氛围探讨记忆与信任。',
    cast: ['北条麻妃', '染谷将太', '二阶堂富美'],
  },
  {
    id: 13,
    title: '春日慢行',
    year: 2022,
    genres: ['爱情', '喜剧'],
    country: '日本',
    director: '矢口史靖',
    runtime: 96,
    language: '日语',
    rating: 7.6,
    releaseDate: '2022-03-18',
    poster:
      'https://readdy.ai/api/search-image?query=Cheerful%20spring%20film%20poster%20with%20a%20woman%20riding%20a%20bicycle%20through%20a%20sunny%20park%20lined%20with%20blooming%20flowers%2C%20light%20hearted%20joyful%20mood%2C%20fresh%20warm%20pastel%20tones%20with%20vivid%20amber%20accents%2C%20tasteful%20airy%20composition%2C%20soft%20daylight%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20premium%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-13&orientation=portrait',
    tagline: '慢一点，才看得见春天的样子。',
    synopsis:
      '一位生活节奏快到喘不过气的都市白领，被公司强制休假一个月。她骑着旧自行车开始了一场没有计划的旅行，却意外遇见了另一种生活的可能。',
    cast: ['北条麻妃', '瑛太', '上野树里'],
  },
  {
    id: 14,
    title: '黄昏车站',
    year: 2017,
    genres: ['剧情'],
    country: '日本',
    director: '山田洋次',
    runtime: 110,
    language: '日语',
    rating: 8.5,
    releaseDate: '2017-06-09',
    poster:
      'https://readdy.ai/api/search-image?query=Nostalgic%20film%20poster%20showing%20a%20woman%20standing%20on%20a%20small%20rural%20train%20platform%20at%20dusk%20as%20a%20train%20departs%2C%20long%20warm%20golden%20shadows%2C%20bittersweet%20farewell%20mood%2C%20warm%20amber%20and%20muted%20brown%20tones%2C%20tasteful%20restrained%20composition%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20premium%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-14&orientation=portrait',
    tagline: '每一次道别，都是新的出发。',
    synopsis:
      '一座即将停运的乡村小站，见证了几十年来无数次的相聚与别离。守站多年的老站长与一位归乡的女儿，在最后一班列车驶离后，终于解开了多年的心结。',
    cast: ['北条麻妃', '高仓健', '倍赏千惠子'],
  },
  {
    id: 15,
    title: '浮世绘卷',
    year: 2023,
    genres: ['历史', '剧情'],
    country: '日本',
    director: '渡边修',
    runtime: 138,
    language: '日语',
    rating: 8.6,
    releaseDate: '2023-11-03',
    poster:
      'https://readdy.ai/api/search-image?query=Artistic%20historical%20film%20poster%20inspired%20by%20Japanese%20ukiyo%20e%20woodblock%20prints%2C%20an%20elegant%20woman%20in%20a%20patterned%20kimono%20depicted%20in%20a%20stylized%20flattened%20perspective%2C%20waves%20and%20clouds%20motifs%2C%20deep%20indigo%20and%20warm%20vermillion%20tones%2C%20tasteful%20decorative%20composition%2C%20textured%20paper%20feel%2C%20high%20detail%2C%20premium%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-15&orientation=portrait',
    tagline: '一幅画，藏着一个时代的心跳。',
    synopsis:
      '故事发生在浮世绘鼎盛的江户时代，一位年轻的画师在传承与创新之间艰难求索。她以女性视角记录下市井百态，也在画卷中留下了属于自己的名字。',
    cast: ['北条麻妃', '中村狮童', '柴崎幸'],
  },
  {
    id: 16,
    title: '潮汐之间',
    year: 2024,
    genres: ['剧情', '爱情'],
    country: '日本',
    director: '小林绫',
    runtime: 120,
    language: '日语',
    rating: 8.8,
    releaseDate: '2024-05-31',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20coastal%20film%20poster%20with%20a%20woman%20standing%20barefoot%20in%20shallow%20tidal%20water%20at%20dusk%2C%20soft%20waves%20and%20gentle%20reflections%2C%20calm%20reflective%20mood%2C%20warm%20amber%20sunset%20and%20deep%20indigo%20sea%20tones%2C%20tasteful%20elegant%20composition%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20premium%20movie%20poster%20aesthetic&width=600&height=900&seq=bhposter-16&orientation=portrait',
    tagline: '潮水退去又涨起，爱从未真正离开。',
    synopsis:
      '一对因误会分开多年的恋人在海边小镇重逢。潮起潮落的七天里，他们重新走过了当初一起走过的每一条路，也终于学会了如何好好告别与重新开始。',
    cast: ['北条麻妃', '佐藤健', '有村架纯'],
  },
];

export const getMovieById = (id: number): Movie | undefined =>
  movies.find((m) => m.id === id);

export const getRelatedMovies = (movie: Movie, limit = 4): Movie[] =>
  movies
    .filter((m) => m.id !== movie.id && m.genres.some((g) => movie.genres.includes(g)))
    .slice(0, limit);